import React from 'react';
import { Helmet } from 'react-helmet';
import { TerminosContainer, TerminosContent } from './estilosTerminos';

function TerminosCondiciones() {
  return (
    <TerminosContainer>
      <Helmet>
        <title>Condiciones del Registro de Dominios - JuanFra Hernández</title>
        <meta
          name="description"
          content="Condiciones del servicio de registro y gestión de dominios conforme a la normativa ICANN"
        />
        <link
          rel="canonical"
          href="https://juanfrahernandez.es/terminos-y-condiciones-dominios"
        />
      </Helmet>

      <TerminosContent>
        <h1>Condiciones del Servicio de Registro y Gestión de Dominios</h1>

        <p>Última actualización: {new Date().toLocaleDateString()}</p>

        <h2>1. Objeto del servicio</h2>
        <p>
          El presente apartado regula las condiciones aplicables al registro,
          renovación, transferencia, mantenimiento y gestión de nombres de
          dominio prestados por <strong>Juan Francisco Hernández Martínez</strong>,
          con DNI <strong>15429989W</strong>, en adelante <strong>el Proveedor</strong>,
          a favor de sus clientes, en adelante <strong>el Cliente</strong>.
        </p>
        <p>
          Estas condiciones serán de aplicación a todos los dominios gestionados
          actualmente o en el futuro por el Proveedor en nombre del Cliente.
        </p>

        <h2>2. Agente Registrador</h2>
        <p>
          El Cliente es informado de que el registro técnico del nombre de dominio
          se realiza a través del Agente Registrador acreditado{' '}
          <strong>DonDominio / Soluciones Corporativas IP, S.L.</strong>, entidad
          autorizada para operar conforme a la normativa de la{' '}
          <strong>ICANN (Internet Corporation for Assigned Names and Numbers)</strong>.
        </p>

        <h2>3. Rol del Proveedor como revendedor (Reseller)</h2>
        <p>
          El Proveedor actúa como <strong>revendedor (reseller)</strong> del servicio
          de registro de dominios, realizando en nombre del Cliente las gestiones
          necesarias para el alta, modificación, renovación y soporte técnico del
          dominio contratado.
        </p>
        <p>El Cliente reconoce y acepta expresamente esta condición.</p>

        <h2>4. Aceptación de las políticas ICANN</h2>
        <p>
          El Cliente declara haber leído, comprendido y aceptar las políticas y
          condiciones establecidas por la ICANN, que resultan de obligado
          cumplimiento para todo titular de un nombre de dominio.
        </p>
        <p>
          Las políticas ICANN pueden consultarse en el siguiente enlace oficial:
        </p>
        <p>
          <a
            href="https://www.icann.org/resources/pages/approved-with-specs-2013-09-17-en"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.icann.org/resources/pages/approved-with-specs-2013-09-17-en
          </a>
        </p>
        <p>
          Estas políticas forman parte integrante de la relación contractual entre
          el Cliente y el Proveedor en lo relativo a la gestión de dominios.
        </p>

        <h2>5. Información educativa y derechos del titular del dominio</h2>
        <p>
          El Cliente es informado de sus derechos y responsabilidades como titular
          de un nombre de dominio, disponibles en los siguientes enlaces oficiales
          de la ICANN:
        </p>
        <ul>
          <li>
            Información educativa sobre el registro de dominios:{' '}
            <a
              href="https://www.icann.org/resources/pages/educational-2012-02-25-en"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.icann.org/resources/pages/educational-2012-02-25-en
            </a>
          </li>
          <li>
            Beneficios y derechos del titular del dominio:{' '}
            <a
              href="https://www.icann.org/resources/pages/benefits-2013-09-16-en"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.icann.org/resources/pages/benefits-2013-09-16-en
            </a>
          </li>
        </ul>

        <h2>6. Consulta del WHOIS</h2>
        <p>
          El Cliente puede consultar en cualquier momento la información pública
          asociada a su nombre de dominio a través del servicio WHOIS oficial de la
          ICANN:
        </p>
        <p>
          <a
            href="https://lookup.icann.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://lookup.icann.org/
          </a>
        </p>

        <h2>7. Servicios de privacidad WHOIS</h2>
        <p>
          El Cliente entiende y acepta que no podrá utilizar servicios de
          privacidad o proxy WHOIS externos al Agente Registrador DonDominio.
        </p>
        <p>
          Únicamente podrán utilizarse los servicios de privacidad ofrecidos
          directamente por dicho registrador, conforme a la normativa ICANN
          vigente.
        </p>

        <h2>8. Prohibición de uso de logotipos ICANN</h2>
        <p>
          Queda expresamente prohibido el uso del logotipo de la ICANN o de
          cualquier registrador acreditado en páginas web, materiales comerciales
          o documentación, salvo autorización expresa del titular de dichos
          derechos.
        </p>

        <h2>9. Exactitud y actualización de los datos</h2>
        <p>
          El Cliente se compromete a facilitar datos reales, veraces y
          actualizados como titular del dominio.
        </p>
        <p>
          La falta de veracidad o actualización de los datos podrá dar lugar a la
          suspensión o cancelación del dominio conforme a la normativa ICANN.
        </p>

        <h2>10. Renovaciones y vencimientos</h2>
        <p>
          El Proveedor realizará las gestiones de renovación del dominio cuando
          exista contrato activo que incluya dicho servicio o cuando el Cliente
          lo solicite expresamente.
        </p>
        <p>
          En todo caso, es responsabilidad del Cliente mantener los pagos al día
          para evitar la pérdida del dominio por expiración.
        </p>

        <h2>11. Aceptación</h2>
        <p>
          El uso continuado de los servicios de registro y gestión de dominios
          implica la aceptación expresa de las presentes condiciones.
        </p>
      </TerminosContent>
    </TerminosContainer>
  );
}

export default TerminosCondiciones;
